import React from 'react'
import WorkCarousel from '../WorkCarousel/WorkCarousel'
import { useRandomWorks } from '../../hooks/useRandomWorks'

const RANDOM_WORKS_COUNT = 6

const WorkBlock = () => {
  const { items, isLoading } = useRandomWorks(RANDOM_WORKS_COUNT)

  return (
    <WorkCarousel
      title="Наши работы"
      items={items}
      isLoading={isLoading}
      sectionClassName="work-carousel--home"
      footerDescription="Короткая визуальная демонстрация результата до и после работ."
    />
  )
}

export default WorkBlock
